/**
 * "TRUCKBUDDY", and on a deployment that names itself, " - Testing" beside it.
 *
 * Eden, 6 October 2026: staging and production should be told apart at a
 * glance, and the difference must not be able to reach production by accident.
 * So the label is never written here: it comes from the deployment
 * (`TB_ENVIRONMENT_LABEL`, set only by staging's deploy and staging's
 * infrastructure), through the public status the shell already polls. The same
 * code on `main` renders the bare brand, because production sets nothing.
 *
 * One component for every place the brand appears -- the nav, the sign-in page
 * and the maintenance page -- so a signed-out tester sees the label too.
 */
import { useSiteMaintenanceStatus } from "../lib/site-maintenance-queries";

export function BrandMark() {
  const label = useSiteMaintenanceStatus().data?.environmentLabel ?? null;
  return (
    <>
      TRUCKBUDDY
      {label ? <span className="nav-brand-env"> - {label}</span> : null}
    </>
  );
}
